// extracted by mini-css-extract-plugin
export default {"moreButton":"lessButton_moreButton__jjaWq","hide":"lessButton_hide__UOMTP"};